/* eslint-disable prettier/prettier */
import { Button, Container } from 'react-bootstrap'
import { Link, Outlet, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import backIcon from 'assets/images/arrow-back.svg'
import { useState } from 'react'
import { PATHS } from 'config/routes'
import circle from 'assets/images/login-circle.svg'
import logo from 'assets/images/logo.svg'
import { useAtom } from 'jotai'
import { mobilePageTitleAtom, roomTitleAtom } from 'config/store'
import InviteModal from 'components/Modal/InviteModal'
import { useLocation } from 'react-router-dom'
import { useEffect, useContext } from 'react'
import { SocketContext } from 'utils/socket'
import SnackbarComponent from 'components/SnackbarComponent'
import { useSelector } from 'react-redux'
import { curState } from 'store/selector'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { useQuery } from 'react-query'
import { getAllGameQuery, getCheckEventBoatRacing102025Query, getCheckEventBoatRacingQuery, getCheckEventBunpimayQuery, getCheckEventWaterQuery, getEventBoatRacing102025Rank, useCheckSub } from 'dataLayer/game'
import WinnerThingyan from 'components/Modal/WinnerThingyan'
import { getUserQuery } from 'dataLayer/user'
import eventIcon from 'assets/images/eventWater/iconEvent.png'
import { getUserinfo, setData } from 'utils/localStorage'
import boatRacingIcon from 'assets/images/eventBoatRacing/boatEventIcon.png'
import WinnerBoatRacing from 'components/Modal/PopupModal/WinnerBoatRacing'
import bunpimayIcon from 'assets/images/eventBunpimay/iconEvent.png'
import ModalWinnerEventBunpimay from 'components/Modal/ModalEvenBunpimay/ModalWinnerEventBunpimay'
import ButtonEvent from 'pages/Event/EventBoatRacingT10/components/ButtonEvent'
import VictoryAnnouncement from 'pages/Event/EventBoatRacingT10/components/VictoryAnnouncement'
import { useTranslation } from 'react-i18next'
import NotificationModal from 'pages/Event/EventBoatRacingT10/components/NotificationModal'
import iconBoat from 'assets/images/eventBoatRacingT10/iconBoat.png'

function SubLayout() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const selector = useSelector(curState)
	const location = useLocation();
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const isMobileLg = useMediaQuery(`(max-width: ${mediaQueryPoint.lg}px)`)
	const mobilePageTitle = useAtom(mobilePageTitleAtom)
	const [roomTitle] = useAtom(roomTitleAtom)
	const { roomId } = useParams()
	const [showVictoryPopup, setShowVictoryPopup] = useState(false);
	const [openModalWinLostT102025, setOpenModalWinLostT102025] = useState(false);
	const userInfo = getUserinfo()
	const [dataCheckSub, setDataCheckSub] = useState()
	const [searchParams] = useSearchParams()
	const codeParams = searchParams.get('code')
	const allowParams = searchParams.get('allow')

	useEffect(() => { //chạy lần đầu khi vào web chuyển đến event
		if( userInfo && codeParams && allowParams === 'true' ){
			return;
		}
		const fromHome = sessionStorage.getItem("fromHome");
		if (fromHome) {
			if (location.pathname === "/" && !fromHome) {
				navigate("/event-boat-racing", { replace: true });
			}
			sessionStorage.removeItem("fromHome");
		} else {
			location.pathname === "/" && navigate("/event-boat-racing", { replace: true })
		}
	}, []);

	const handleSeeDetail = () => {
		setShowVictoryPopup(false)
		navigate('/event-boat-racing', { state: "RANK" })
	}

	const { data: games } = useQuery(getAllGameQuery())

	let dataSelect = games && games.find(item => item.id == roomId)
	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())
	const { data: eventWater, refetch: refetchEvent } = useQuery(
		getCheckEventWaterQuery(),
	)
	const { data: eventBoatRacing, refetch: refetchEventBoatRacing } = useQuery(
		getCheckEventBoatRacingQuery(),

	)
	const { data: eventBunpimay, refetch: refetchEventBunpimay } = useQuery(
		getCheckEventBunpimayQuery(),
	)

	const { data: eventBoatRacing102025, refetch: refetchEventBoatRacing102025 } = useQuery(
		getCheckEventBoatRacing102025Query(),
	)
	const {
		data: rankRacing102025,
		refetch: fetchEventBoatRacing102025Rank,
	} = useQuery(
		getEventBoatRacing102025Rank({
			my_rank: 1,
			limit: 1,
		})
	)


	useEffect(() => {
		// refetchEvent()
		// refetchEventBoatRacing()
		// refetchEventBunpimay()
		refetchEventBoatRacing102025()
	}, [user])

	const { mutate: mutateCheckSub } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			setDataCheckSub(data?.data)

			const storagePackageKey = `isPopupShownPackage_T10-2025`;
			const alreadyShownPackage = localStorage.getItem(storagePackageKey);

			if (!alreadyShownPackage) {
				localStorage.setItem(storagePackageKey, "true");
				!!userInfo && data?.data?.isSub === false && setOpenModalWinLostT102025(true)
			}
		}
	})

	useEffect(() => {
		(location?.pathname === '/' && !!userInfo) && mutateCheckSub(
			allowParams == 'true' && codeParams
				? { location: "HOME", from: "auto" }
				: undefined
		)
	}, [location?.pathname, user])

	useEffect(() => {
		const endDate = new Date(eventBoatRacing102025?.end_time_finish);
		const isFinished = eventBoatRacing102025?.is_finished === 1;
		const now = new Date();
		const isExpired = now > endDate;

		if (isFinished && isExpired) {
			fetchEventBoatRacing102025Rank();
		}
	}, [eventBoatRacing102025])


	const [phone, setPhone] = useState('')

	const { socket, setSocketRoomId } = useContext(SocketContext)
	useEffect(() => { }, [selector])
	useEffect(() => {
		setData('list-user-play', [])
	}, [location.pathname])
	const { showSnackbar } = selector
	useEffect(() => {
		if (location.pathname.indexOf(PATHS.PLAYROOM_PAGE.replace(':roomId/:gameId', '')) === -1) {
			if (location.state && location.state.previous !== undefined) {
				if (location.state.previous.indexOf(PATHS.PLAYROOM_PAGE.replace(':roomId/:gameId', '')) !== -1) {
					const dataRoom = location.state.previous.split('/');
					socket.emit('leave room', { room_id: dataRoom[dataRoom.length - 1] });
					window.history.replaceState({}, document.title)
				}
			} else
				setSocketRoomId(0)
			document.body.classList.remove('disable-scroll')
		}
	}, [location])
	const handleBack = () => {

		if (location.pathname == "/confirm-otp" && isMobileMD) {
			navigate(PATHS.LOGIN_OTP_MOBILE)

		} else if (location.pathname.includes('/room') && isMobileMD) {
			navigate(PATHS.HOME_PAGE)
		} else {
			navigate(-1)
		}
	}
	const listPathRemoveIconEvent = [
		PATHS.EVENT_WATER_PAGE,
		PATHS.RESULT_EVENT_WATER_PAGE,
		PATHS.EVENT_BOAT_RACING_PAGE,
		PATHS.RESULT_EVENT_BOAT_RACING_PAGE,
		PATHS.BUNPIMAY_PAGE_HOME
	]

	useEffect(() => {
		const endDate = new Date(eventBoatRacing102025?.end_time_finish);
		const now = new Date();
		const isExpired = now > endDate;

		const isTopUser = userInfo?.userId === rankRacing102025?.ranks?.data[0]?.userId;

		const storageKey = `victoryPopupShown_T10-2025`;
		const alreadyShown = localStorage.getItem(storageKey);

		if (
			userInfo?.userId &&
			!alreadyShown &&
			isExpired &&
			isTopUser
		) {
			localStorage.setItem(storageKey, "true");
			setShowVictoryPopup(true);
		}
	}, [eventBoatRacing102025, userInfo, rankRacing102025]);

	return (
		<div className="sub-layout-container">
			<div className='fly-water' id='show-water' />
			<div className='fly-water' id='show-item-fly' />
			<div className='fly-boat-racing' id='show-boat-racing' />
			<span
				id="icon-event"
				onClick={() => {
					if (!eventWater?.is_finished) {
						navigate(PATHS.EVENT_WATER_PAGE)
					} else {
						navigate(PATHS.RESULT_EVENT_WATER_PAGE)
					}
				}}
				className={`sub-layout-container_icon-event ${!eventWater?.is_show ||
					(isMobileMD &&
						listPathRemoveIconEvent.indexOf(location.pathname) !== -1)
					? 'none'
					: ''
					}`}
			>
				<img src={eventIcon} />
			</span>
			{/* <span
				id="icon-event-boat-racing"
				onClick={() => {
					if (!eventBoatRacing?.is_finished) {
						navigate(PATHS.EVENT_BOAT_RACING_PAGE)
					} else {
						navigate(PATHS.RESULT_EVENT_BOAT_RACING_PAGE)
					}
				}}
				className={`sub-layout-container_icon-event ${!eventBoatRacing?.is_show ||
					(isMobileLg &&
						listPathRemoveIconEvent.indexOf(location.pathname) !== -1)
					? 'none'
					: ''
					}`}
			>
				<img srcSet={`${boatRacingIcon} 2x`} />
			</span> */}
			{/* <span
				id="icon-event-bunpimay"
				onClick={() => {
					if (!eventBunpimay?.is_finished) {
						navigate(PATHS.BUNPIMAY_PAGE_HOME)
					} else {
						navigate(PATHS.BUNPIMAY_PAGE_HOME, {
							state: {
								rank: 'rank'
							}
						})
					}
				}}
				className={`sub-layout-container_icon-event ${!eventBunpimay?.is_show ||
					(isMobileLg &&
						location.pathname.includes('/bunpimay'))
					? 'none'
					: ''
					}`}
			>
				<img srcSet={`${bunpimayIcon} 2x`} />
			</span> */}
			<Container fluid className="header-sublayout">
				<Button variant="dark" onClick={handleBack}>
					<img src={backIcon} alt="back" />
				</Button>
				{window.location.pathname === PATHS.LOGIN_PASS_MOBILE ?
					<Link to={PATHS.HOME_PAGE}>
						<img
							alt="Logo's website"
							src={logo}
							width="95"
							height="38"
						/>
					</Link> :
					<h1
						className={
							window.location.pathname === PATHS.LOGIN_OTP_MOBILE ||
								window.location.pathname === PATHS.OTP_MOBILE
								? 'otp-login'
								: null
						}
					>
						{window.location.pathname.split('/')[1] === PATHS.ROOM_PAGE.split('/')[1] && window.location.pathname.split('/')[3] == null ? dataSelect?.name || roomTitle : mobilePageTitle}
					</h1>}
			</Container>
			<img src={circle} width="90" alt="" className="circle2" />

			<Outlet context={{ phone, setPhone }} />
			<SnackbarComponent
				runSnackBar={showSnackbar.open}
				content={showSnackbar.content}
				severity={showSnackbar.severity}
			/>
			<InviteModal />
			{eventWater?.is_show && eventBoatRacing?.is_finished ? <WinnerThingyan /> : null}
			{eventBoatRacing?.is_show && eventBoatRacing?.is_finished ? <WinnerBoatRacing /> : null}
			{eventBunpimay?.is_show && eventBunpimay?.is_finished ? <ModalWinnerEventBunpimay /> : null}

			{eventBoatRacing102025?.is_show === 1 && <ButtonEvent />}
			<VictoryAnnouncement show={showVictoryPopup} handleCancel={() => setShowVictoryPopup(false)} handle={handleSeeDetail} />

			{/* show thắng chưa mua gói */}
			<NotificationModal
				show={openModalWinLostT102025}
				title={t('event.event_boa_racing_t10.notice')}
				content={t('event.event_boa_racing_t10.you_need_to_subscribe_to_the_dailysub_package_to_participate_in_the_boun_suang_heua_event_and_receive_many_valuable_rewards')}
				footer={
					<>
						<button onClick={() => {
							navigate('/event-boat-racing')
							setOpenModalWinLostT102025(false)
						}} className='button-event'>
							<img src={iconBoat} alt="iconBoat" className='icon-boat-event' />
							{t('event.event_boa_racing_t10.visit_event')}
						</button>
						<button onClick={() => {
							if (dataCheckSub?.urlWebView) {
								window.location.href = dataCheckSub?.urlWebView;
							}
						}}
							className='button-continue'>
							{t('event.event_boa_racing_t10.buy_package')}
						</button>
					</>}
				handleCancel={() => setOpenModalWinLostT102025(false)}
			/>
		</div>
	)
}

export default SubLayout
